module.exports = __webpack_public_path__ + "img/ybg.091d1f44.png";